import React, { useState } from "react"
import {
  Link,
  useI18next,
  useTranslation,
} from "@zestia/gatsby-plugin-react-i18next"
import blogCategories from "@/data/blog-categories"

const BlogCategoryNavigationItem = ({ to, category, gtmLabel, children }) => {
  const { originalPath } = useI18next()

  const pageCategory = /\/blog\/category\/(\w+)/.exec(originalPath)?.[1]

  const isActive = to === originalPath || category === pageCategory

  return (
    <li
      className={`blog-category-navigation__item ${
        isActive ? "blog-category-navigation__item--active" : ""
      }`}
    >
      <Link to={to}>{children}</Link>
    </li>
  )
}

const BlogCategoryNavigation = ({ className = "" }) => {
  const { t } = useTranslation()

  const { originalPath } = useI18next()

  const [isOpen, setIsOpen] = useState(false)

  const pageCategory = /\/blog\/category\/(\w+)/.exec(originalPath)?.[1]

  // Check when user is on the blog homepage (no category selected)
  const isBlogHomepage = !pageCategory

  return (
    <nav
      className={`blog-category-navigation ${className} ${
        isOpen ? "blog-category-navigation--active" : ""
      }`}
    >
      <div className="container-fluid">
        <div className="blog-category-navigation__sections row">
          {/* Current category title */}
          <div className="blog-category-navigation__current-category col-xs-12 col-md-3 col-lg-4">
            <h1 className="mb-0">
              {t(`blog.home.title.${pageCategory ? pageCategory : "all"}`)}
            </h1>

            {/* Show description on blog homepage */}
            {isBlogHomepage && <p>{t("blog.home.description.all")}</p>}
          </div>

          {/* Category Selection */}
          <div className="col-xs-12 col-md-9 col-lg-8">
            <div className="blog-category-navigation__items-wrapper">
              {/* Toggle button */}
              <button
                className="blog-category-navigation__toggle-button"
                onClick={() => setIsOpen(prev => !prev)}
                aria-label={t("blog.toggle-show-categories")}
              >
                {t("blog.categories")}
                <svg
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m12 13.1719 4.95-4.94998 1.414 1.414-6.364 6.36398-6.36401-6.36398 1.414-1.414z"
                    fill="#fff"
                  ></path>
                </svg>
              </button>

              <ul className="blog-category-navigation__items">
                <BlogCategoryNavigationItem to="/blog/" gtmLabel="All Link">
                  {t("blog.latest-news")}
                </BlogCategoryNavigationItem>

                {blogCategories.map(category => (
                  <BlogCategoryNavigationItem
                    key={category}
                    to={`/blog/category/${category}/`}
                    category={category}
                    gtmLabel={`${
                      category.charAt(0).toUpperCase() + category.slice(1)
                    } Link`}
                  >
                    {t(`blog.category.${category}`)}
                  </BlogCategoryNavigationItem>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default BlogCategoryNavigation
